<template>
  <!-- F5 로그인 잠금 정책 안내 — 정책 문구는 i18n acc_lock_policy_guide 단일 키(중앙화).
       BE 정책 상수(china-inapi lock-policy.constants.ts: 5회/15분) 변경 시 함께 갱신할 것. -->
  <span style="font-size: 12px; color: #999; white-space: nowrap;">
    <a-tooltip :overlay-style="{ maxWidth: '380px', whiteSpace: 'pre-line' }" :title="$t('acc_lock_policy_guide')">
      <QuestionCircleOutlined style="color: rgba(0, 0, 0, 0.45); cursor: help;" />
      <span v-if="showLabel" style="margin-left: 4px;">{{ $t('acc_lock_policy_label') }}</span>
    </a-tooltip>
  </span>
</template>

<script>
import { QuestionCircleOutlined } from '@ant-design/icons-vue';

export default {
  name: 'LockPolicyHint',
  components: { QuestionCircleOutlined },
  props: {
    showLabel: { type: Boolean, default: true },
  },
};
</script>
